import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import reducerCatalog from '../../reducers'
import getWindowState from '../common/get-window-state'
import getCompose from './get-compose'
import history from '../history'
import { connectRouter, routerMiddleware } from 'connected-react-router'

const createReduxStore = () => {
    const compose = getCompose()
    const windowState = getWindowState()
  
    return createStore(
        combineReducers({
            router: connectRouter(history),
            ...reducerCatalog
        }),
        windowState.__REDUX_DEVTOOLS_EXTENSION__ && windowState.__REDUX_DEVTOOLS_EXTENSION__(),
        compose(applyMiddleware(routerMiddleware(history), thunk))
    )
}

export default createReduxStore